import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import Model from "@ckeditor/ckeditor5-ui/src/model";
import Collection from "@ckeditor/ckeditor5-utils/src/collection";
import FileDialogButtonView from '@ckeditor/ckeditor5-upload/src/ui/filedialogbuttonview';

import {
    addListToDropdown,
    createDropdown
} from "@ckeditor/ckeditor5-ui/src/dropdown/utils";

import SplitButtonView from "@ckeditor/ckeditor5-ui/src/dropdown/button/splitbuttonview";
import Icon from './../icons/icon_multimedia.svg';
import iconMedia from './../icons/media.svg';
import iconSlider from './../icons/icon_slider.svg';
import iconForm from './../icons/icon_form.svg';
import iconOpros from './../icons/icon_opros.svg';
import iconAddress from './../icons/icon_address.svg';
import iconHtml from './../icons/html.svg';
import iconPolls from './../icons/icon_quiz.svg';

export default class MultiMediaDropDown extends Plugin {
    init() {
        const editor = this.editor;
        editor.ui.componentFactory.add("MultiMediaDropDown", locale => {
            const dropdownView = createDropdown(locale, SplitButtonView);
            dropdownView.buttonView.actionView.set({
                withText: false,
                label: "Мультимедиа",
                icon: Icon,
                tooltip: true
            });
            dropdownView.class = 'comp_g';
            const items = new Collection();
            items.add({
                type: "button",
                model: new Model({
                    id: 'mediaEmbed',
                    withText: false,
                    icon: iconMedia,
                    label: "Видео, Iframe",
                    tooltip: true
                })
            });
            items.add({
                type: "button",
                model: new Model({
                    id: 'slider',
                    withText: false,
                    icon: iconSlider,
                    label: "Слайдер",
                    tooltip: true
                })
            });
            items.add({
                type: "button",
                model: new Model({
                    id: 'opros',
                    withText: false,
                    label: "Опрос",
                    icon: iconOpros,
                    tooltip: true
                })
            });
            // items.add({
            //     type: "button",
            //     model: new Model({
            //         id: 'contact',
            //         withText: false,
            //         icon: iconAddress,
            //         label: "Адресный блок",
            //         tooltip: true
            //     })
            // });
            // items.add({
            //     type: "button",
            //     model: new Model({
            //         id: 'form',
            //         withText: false,
            //         icon: iconForm,
            //         label: "Форма",
            //         tooltip: true
            //     })
            // });
            items.add({
                type: "button",
                model: new Model({
                    id: 'htmlEmbed',
                    withText: false,
                    label: "HTML-код",
                    icon: iconHtml,
                    tooltip: true
                })
            });
            addListToDropdown(dropdownView, items);
            dropdownView.on('execute', (eventInfo) => {
                const {id, label} = eventInfo.source;

                if (id === 'htmlEmbed') {
                    editor.execute('htmlEmbed')
                } else if (id === 'polls') {
                    editor.execute('insertPoll')
                } else if (id === 'opros') {
                    editor.execute('insertOpros')
                } else if (id === 'contact') {
                    editor.execute('insertContactBlock')
                } else if (id === 'slider') {
                    editor.execute('insertSliderInMaterial')
                } else if (id === 'form') {
                    editor.execute('insertForma')
                } else if (id === 'mediaEmbed') {
                    const url = prompt('Вставьте URL (для YouTube) или IFrame');
                    if (url !== null) {
                        let url_new;
                        console.log(url);
                        if (url.indexOf('iframe') + 1) {
                            let tmp = document.createElement('div');
                            tmp.innerHTML = url;
                            let elem = tmp.getElementsByTagName('iframe')[0];
                            url_new = elem['src'];
                        }
                        url_new = url;
                        editor.execute('mediaEmbed', url_new);
                    }
                }
            });


            return dropdownView;
        });
    }
}
